import { Injectable } from '@angular/core';
import { AuthService } from '@mydocma/auth';
import { NotificationService } from '@mydocma/component-library/src/lib/notification';
import { CustomTaskFileDownloadService } from '@mydocma/task';
import { TranslateService } from '@ngx-translate/core';
import { ErrorHandlingService } from 'projects/mydocma/pr/src/lib/services/error-handling.service';

@Injectable()
export class CustomFileDownloadService extends CustomTaskFileDownloadService {
  private jwtService: any;
  constructor(
    private readonly notificationService: NotificationService,
    private readonly errorHandlingService: ErrorHandlingService,
    private readonly translateService: TranslateService,
    private readonly authService: AuthService,
  ) {
    super();
    this.jwtService = this.authService as any;
  }

  public async downloadFile(
    fileOrUrl: string | File,
    options: {
      fileName?: string;
      open?: boolean;
      preventBrowserDownload?: boolean;
    },
  ): Promise<File> {
    try {
      let file: File;

      if (typeof fileOrUrl === 'string') {
        let urlToDownload = fileOrUrl;
        const token = this.jwtService.getAccessToken?.();
        try {
          const urlObj = new URL(fileOrUrl, window.location.origin);
          if (token) {
            urlObj.searchParams.set('token', token);
          }
          urlToDownload = urlObj.toString();
        } catch (error) {
          this.notificationService.error('Invalid URL: ' + fileOrUrl);
          throw error;
        }

        const response = await fetch(urlToDownload, { method: 'GET' });
        if (!response.ok) {
          throw new Error(`Download failed with status ${response.status}`);
        }

        const anchor = document.createElement('a');
        anchor.href = urlToDownload;
        anchor.download = options.fileName || 'download';
        anchor.style.display = 'none';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        file = new File([], options.fileName || 'download');
      } else {
        file = fileOrUrl;
      }

      return file;
    } catch (error) {
      this.errorHandlingService.handle(
        error,
        this.translateService.instant('PR.documents.notifications.downloadError'),
      );
      throw error;
    }
  }
}
